import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-assigned-users-dialog',
  templateUrl: './assigned-users-dialog.component.html',
  styleUrls: ['./assigned-users-dialog.component.css'],
  standalone: false
})
export class AssignedUsersDialogComponent implements OnInit {
  displayedColumns: string[] = ['users'];
  dataSource: MatTableDataSource<{ users: string }>;
  constructor(public dialogRef: MatDialogRef<AssignedUsersDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
      const userArray = Array.isArray(this.data?.users) ? this.data.users : [];
    this.dataSource = new MatTableDataSource(userArray.map(user => ({ users: user })));
  }

   onClose(): void {
    this.dialogRef.close();
  }
}
